import '../../css/searchPage.css'

import { FC, useCallback, useState } from "react";
import { useHistory } from "react-router-dom";

import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import debounce from "lodash/debounce"

import { UseGetFlag } from "../../app/launchDarkly";
import { setSearchString } from "../../app/search/search.slice";
import { getQuerySearchList } from "../../app/search/search.thunk";
import { SearchHit } from "../../app/search/search.types";
import { useAppDispatch, useAppSelector } from "../../app/store/hooks";
import useLogRecipeEdit from '../../hooks/useLogRecipeEdit';
import { ReactComponent as SearchIcon } from "../../svg/searchIcon.svg";
import { ReactComponent as SortIcon } from "../../svg/sortIcon.svg";
import { EventLogsEnum } from '../../utils/events';
import { resizeImageIfCloudinary } from '../../utils/images/cloudinaryUtils';
import Filter from "./filterPage";
import ListCard from "./listCard";
import styles from "./searchBar.module.css";
import Sort from "./sortDrawer";

const SearchListCard: FC<{ option: SearchHit, handleUserLevelRecipes: (recipeId: string) => void }> = ({ option, handleUserLevelRecipes }) => {
	const defaultImage = "https://images.pexels.com/photos/6448483/pexels-photo-6448483.jpeg?auto=compress&cs=tinysrgb&w=1440&h=80&dpr=1"
	const imageUrl = option?.metadata?.url ?? defaultImage
	const resizedImage = resizeImageIfCloudinary(imageUrl, 48, 48, -1, -1, true)
	if (option?.metadata?.name) {
		return (
			<ListCard
				image={resizedImage}
				key={option.id}
				onClick={() => handleUserLevelRecipes(option?.id)}
				title={option?.metadata?.name}
			/>
		)
	}
	return null
}

const SearchBar: FC = () => {

	const searchString = useAppSelector(state => state.search.searchString)
	const { logRecipeEdit } = useLogRecipeEdit();

	const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
	const searchFilteredRecipes = useAppSelector((state) => state.search.searchFilteredRecipes);
	const [sortDrawer, setSortDrawer] = useState(false)
	const { enableAlgoliaSearch, enableAdminFeatures } = UseGetFlag()

	const dispatch = useAppDispatch();

	const history = useHistory();
	const handleUserLevelRecipes = (recipeId: string) => {
		logRecipeEdit(EventLogsEnum.APP_RECIPE_OPENED, {
			eventData: { recipeId, source: 'search' }
		})
		const currPath = `recipe/${recipeId}`;
		history.push(currPath);
	};

	const debounceHandler = (queryString: string) => dispatch(getQuerySearchList({ enableAlgoliaSearch, enableAdminFeatures, queryString }))
	const debouncedQuerySearchService = useCallback(debounce(debounceHandler, 500), [enableAlgoliaSearch, enableAdminFeatures])

	const typeHandler = (queryString: string) => {
		if (!isSearchModalOpen) setIsSearchModalOpen(true)
		dispatch(setSearchString(queryString))
		debouncedQuerySearchService(queryString)
	};

	return (
		<div>
			<Box className="searchBarPage" sx={{ backgroundColor: '#FCF8EA', mx: 2, display: 'flex', alignItems: 'center' }} >
				<div className={styles.search_icon}>
					<SearchIcon />
				</div>
				<div className={styles.sort_icon} onClick={(e) => { setSortDrawer(true); e.preventDefault() }}>
					<SortIcon />
				</div>

				<Autocomplete
					className="searchBar"
					disablePortal
					filterOptions={(option) => option}
					getOptionLabel={(option) => option.metadata.name}
					id="combo-box-demo"
					inputValue={searchString}
					onClose={() => setIsSearchModalOpen(false)}
					open={isSearchModalOpen && !!searchString}
					options={searchFilteredRecipes}
					renderInput={(params) =>
						<TextField {...params}
							className='searchPage'
							onChange={(e) => typeHandler(e.target.value)}
							placeholder='Search'
							style={{ backgroundColor: '#fff', outline: 0, borderRadius: '10px' }}
						/>
					}
					renderOption={(props, option) => (
						<div className={styles.search_list_card}>
							<SearchListCard handleUserLevelRecipes={handleUserLevelRecipes} option={option} />
						</div>
					)}
					sx={{ width: '100%' }}
				/>
			</Box>
			<Filter />
			<Sort drawerOpen={sortDrawer} setSortDrawer={setSortDrawer} />
		</div>
	)
};

export default SearchBar